import styles from '../css/CarruselMarcas.module.scss'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
export const CarruselMarcas = ({ logos }) => {
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 4,
            slidesToSlide: 2
        },
        desktop: {
            breakpoint: { max: 3000, min: 1150 },
            items: 4,
            slidesToSlide: 2
        },
        tablet: {
            breakpoint: { max: 1150, min: 960 },
            items: 3,
            slidesToSlide: 1
        },
        tablet2: {
            breakpoint: { max: 960, min: 600 },
            items: 2,
            slidesToSlide: 1
        },
        mobile: {
            breakpoint: { max: 600, min: 0 },
            items: 1,
            slidesToSlide: 1
        }
    };
    return (
        <>            
            <div className={'py-3 ' + styles.carrusel}>
                <Carousel responsive={responsive}
                swipeable={false}
                draggable={false}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={4000}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={1000}
                containerClass="carousel-container text-center"
                arrows={false}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px">
                    {Object.values(logos).map(function (logo) {
                        return (
                            <img src={logo} className="d-inline-block" />
                        )
                    })}
                </Carousel>
            </div>


        </>
    )
}